<template>
    <select-campo-component
        v-if="sport"
        :esporte="sport"
        :show="true"
        @hide="back"
        @select="selectCampo"
    ></select-campo-component>
</template>

<script>
import SelectCampoComponent from "@/components/SelectCampoComponent.vue";
import { boardUrl, getToken } from "@/utilities/Api";
import { mapMutations, mapActions } from "vuex";
export default {
    name: "CampsView",
    components: {
        SelectCampoComponent,
    },
    data() {
        return {
            esporte: null,
            video: null,
            sport: null,
            board: false,
        };
    },
    async created() {
        this.esporte = this.$route.query.esporte;
        this.video = this.$route.query.video || null;
        this.board = this.$route.query.board || false;

        this.SET_LOADING(true);

        try {
            const res = await this.get({ url: `sports/${this.esporte}` });
            this.sport = res.data;
        } catch (e) {
            await this.$alert({ title: "erro", icon: "error" });
            this.back();
        }
        this.SET_LOADING(false);
    },
    methods: {
        ...mapActions(["get"]),
        ...mapMutations(["SET_LOADING"]),
        back() {
            if (this.board) {
                this.$router.push(`/select-board`);
            } else {
                this.$router.push(this.video ? "/videos" : "/formacoes");
            }
        },
        selectCampo(id) {
            if (this.video) {
                // abrir nova aba e voltar
                const name = id
                    .replace(/\/+$/, "")
                    .split("/")
                    .pop()
                    .replace(/\.[^/.]+$/, "");
                window.open(
                    `${boardUrl}?sport_id=${this.esporte}&camp=${name}&token=${getToken()}&lang=${localStorage.getItem("lang_code")}`,
                );
                this.$router.replace("/videos");
            } else {
                if (this.board) {
                    this.$router.push(
                        `/board?esporte=${this.esporte}&camp=${id}`,
                    );
                } else {
                    this.$router.push(
                        `/marcar?esporte=${this.esporte}&camp=${id}${this.video ? "&video=true" : ""}`,
                    );
                }
            }
        },
    },
};
</script>
